export const services = {
  label: 'Services & Tools',
  heading: '전개 중인 서비스・도구',
  intro:
    'SNS, 각종 관리 도구, 커뮤니티 기능을 이곳에서 순차적으로 공개합니다. "자세히 보기"를 클릭하면 각 서비스의 상세 내용을 확인하실 수 있습니다.',
  comingSoonTitle: '더 많은 서비스・도구를 준비 중',
  comingSoonBody:
    'EachTeach는 지속적으로 새로운 도구와 리소스를 추가할 예정입니다. 커뮤니티에 등록하고 최신 정보를 받아보세요.',

  // ServiceCard
  card: {
    showDetail: '자세히 보기',
    close: '닫기',
    openLink: '링크 열기',
  },
};
